import script from "./WorkStationLinkPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkStationLinkPage.vue?vue&type=script&lang=ts&setup=true"

import "./WorkStationLinkPage.vue?vue&type=style&index=0&id=42b21b1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b21b1e"]])

export default __exports__